module.exports = __webpack_public_path__ + "img/document.f0d99157.svg";